import { EvaluationResponseStatus } from 'enum/evaluationResponseStatus.enum'
import { IEvaluationResume } from 'models/evaluation.model'

const isAttemptCompleted = (evaluation: IEvaluationResume): boolean =>
  evaluation.status === EvaluationResponseStatus.completed ||
  (evaluation.completionDate != null && evaluation.completionDate !== '')

/**
 * Indica si una evaluación obligatoria bloquea avanzar de lección o finalizar el curso.
 *
 * - `approvalRequired === true`: hace falta **aprobar** para destrabar el avance (el payload/API siempre incluye el booleano).
 * - `approvalRequired === false`: basta con **completar** un intento; el reprobado sigue calculándose en backend/reportes.
 */
export const mandatoryEvaluationBlocksAdvance = (
  evaluation: IEvaluationResume
): boolean => {
  if (!evaluation.required) {
    return false
  }
  if (evaluation.approvalRequired === true) {
    return !evaluation.approved
  }
  return !isAttemptCompleted(evaluation)
}
